var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.list}},[_c('el-table-column',{attrs:{"prop":"order_no","label":"订单号","width":"180"}}),_c('el-table-column',{attrs:{"prop":"day_num","label":"天"}}),_c('el-table-column',{attrs:{"prop":"remark","label":"备注"}}),_c('el-table-column',{attrs:{"prop":"created_at","label":"下单时间"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }